import utils from "@/utils";
import $api from "@/service";

//给备注公共组件提供数据驱动的vuex模块
export default {
    state : {
        //备注类型 1-项目，2-载体
        type : "1",
        //项目|载体id
        id : "0",
        //是否是官方项目[项目专用字段]
        isAdmin : "0",
        //已经加载完成的部分 0-未加载，1-加载中，2-加载完毕
        initStatus : {
            noteOptions : 0,
            contactList : 0,
            atUserList : 0,
            remarkData : 0,
        },
        //写备注左侧表单所需备选项
        noteOptions : {
            //项目状态
            status : [],
            //联系对象
            contact : [],
            //联系类型
            contactType : [],
            //项目进度
            progress : [],
        },
        //联系人备选项
        contactList : {
            //最近联系人
            nearBy : [],
            //常用联系人
            always : [],
            //官方联系人
            official: [],
        },
        //可以@的人的列表
        atUserList : [],
        //备注列表
        remarkData : [],
        //备注区选中的搜索条件
        searchItem : {
            //备注人员
            creator : "0",
            //联系对象
            contactUser : "0",
            //联系类型
            contactType : "0",
            //有效跟进
            effectFollow : "0",
            //具体时间
            dateRange : [],
            //是否显示由回复生成的备注
            showReplyRemark : false,
        },
        //备注区编辑框额外携带的字符串（用于在全局任意位置进行@操作）
        extraStr : "",
        //新增备注loading状态
        addLoading : false,
        //是否清空文本域标志位
        doClearTextArea : false,
        //修改备注loading状态
        editLoading : false,
        //回复备注的loading状态
        replyLoading : false,
        //刷新最近联系人进行状态
        refreshNearByLoading : false,
        //项目备注回访时间及文本域默认值规则，date-指年月日默认几天后，text-指文本域默认文字
        defaultOptionsRule : {
            "4" : {date:7 , text:""},             //重点
            "1" : {date:7 , text:""},             //接洽中
            "5" : {date:60 , text:"暂缓"},        //暂缓
            "2" : {date:14 , text:""},            //成功
            "3" : {date:"" , text:"回收站"},      //回收
        }
    },
    getters : {
        //数据加载状态,true-加载完毕
        loadingStatus:state=>{
            let res = true;
            for(let i in state.initStatus){
                if(state.initStatus[i] !== 2){
                    res = false;
                    break;
                }
            }
            return res;
        },
        //新增数据loading状态
        addRemarkLoading: state =>{
            return state.addLoading;
        },
        //编辑数据loading状态
        editRemarkLoading:state =>{
            return state.editLoading;
        },
        //回复备注的loading状态
        replyRemarkLoading : state => {
            return state.replyLoading;
        },
        //可以被at到的用户名数组
        atUsers : state=>{
            let res = [];
            res = state.atUserList.map(function(v){return v.username;});
            return res;
        },
        //提供监听而用的所有备注
        remarkAll : state => {
            return state.remarkData;
        },
        //置顶的备注
        topRemark : state=>{
            let res = [];
            if(state.remarkData.length <= 0){
                return res;
            }
            for(let i = 0 ; i < state.remarkData.length ; i++){
                if(state.remarkData[i].istop === "1"){
                    res.push(state.remarkData[i]);
                }
            }
            return res;
        },
        //备注区显示的备注
        remarkList : state=>{
            //搜索条件
            let search = state.searchItem;
            //结果
            let res = [];
            if(!state.remarkData || state.remarkData.length <= 0){
                return res;
            }
            if(!search){
                res = state.remarkData;
                return res;
            }

            //筛选列表数据
            for(let i = 0 ; i < state.remarkData.length; i++){
                //验证数据是否该留下

                //1.备注时间
                //起始时间
                if(search.dateRange[0] && search.dateRange[0] !== "" && parseInt(state.remarkData[i].timestamp) < search.dateRange[0]){continue;}
                //结束时间c
                if(search.dateRange[1] && search.dateRange[1] !== "" && parseInt(state.remarkData[i].timestamp) > search.dateRange[1]){continue;}
                //2.备注人员
                if(search.creator && search.creator !== "0" && state.remarkData[i].uid !== search.creator){continue;}
                //3.联系对象
                if((search.contactUser && search.contactUser !== "0" && state.remarkData[i].contactUid !== search.contactUser)
                    || (state.remarkData[i].isAdmin==="1" && search.contactUser && search.contactUser !== "0" && state.remarkData[i].contactUid === search.contactUser)){continue;}
                //4.联系类型
                if((search.contactType && search.contactType !== "0" && state.remarkData[i].contact_type_id !== search.contactType)
                    || (state.remarkData[i].isAdmin==="1" && search.contactType && search.contactType !== "0" && state.remarkData[i].contact_type_id === search.contactType) ){continue;}
                //5.有效跟进
                if(search.effectFollow && search.effectFollow !== "0" && state.remarkData[i].effective_follow !== search.effectFollow){continue;}
                //6.是否显示由回复生成的备注 字段
                if(search.showReplyRemark !== true && state.remarkData[i].commentAndCloud==="1"){continue;}

                res.push(state.remarkData[i]);
            }
            return res;
        },
        //备注区的动态搜索项
        remarkSearchOptions : (state,getters)=>{
            let list = {
                //备注时间
                date : [
                    {name : "全部",value : "0"},
                    {name : "最近7天",value : "7"},
                    {name : "最近15天",value : "15"},
                    {name : "最近30天",value : "30"},
                    {name : "最近60天",value : "60"},
                ],
                //备注人员,status-项目状态,progress-项目进度,returnDate-回访时间点
                creator : [{name : "全部",value : "0",status:"",progress:"",returnDate:""}],
                //联系对象
                contactUser : [{name:"全部",value:"0"}],
                //联系类型 number-总数
                contactType : [{name:"全部",value:"0",number:0}],
                //有效跟进
                effectFollow : [
                    {name:"全部",value:"0"},
                    {name:"有效",value:"2"},
                    {name:"其他",value:"1"},
                ],
            };

            let res = {};
            if(!getters.remarkList || getters.remarkList.length <= 0 ){
                res = list;
                return res;
            }

            //1.备注人员
            //用来查重备注人员备选项的数组
            let creatorUidRecord = [];          //备注人uid
            let creatorCreateTimeRecord = [];   //备注时间戳
            //显示备注人员备选项数据
            let creatorAll = [];

            //2.联系对象
            //用来查重的联系对象uid备选项数组
            let contactUserUidRecord = [];
            //联系对象备选项数组
            let contactUser = [];

            //3.联系类型
            let contactTypeIdRecord = [];
            //联系类型备选项数组
            let contactType = [];
            //联系类型全部总数
            let total = 0;
            //循环取需要的数据(代码杂乱，算法一般，日后有空我必研究算法好好优化一下)
            for(let i = 0 ; i < getters.remarkList.length ; i++){
                //计算备注人员
                if(getters.remarkList[i].uid){
                    //若没有则添加
                    if(creatorUidRecord.indexOf(getters.remarkList[i].uid) === -1){
                        //push
                        creatorUidRecord.push(getters.remarkList[i].uid);
                        creatorCreateTimeRecord.push(getters.remarkList[i].timestamp);

                        creatorAll.push(
                            {
                                name : getters.remarkList[i].username,
                                value : getters.remarkList[i].uid,
                                status: getters.remarkList[i].status,
                                progress:getters.remarkList[i].progress,
                                returnDate:getters.remarkList[i].nexttime,
                                isAdmin : getters.remarkList[i].isAdmin
                            }
                        );
                    }
                    //若存在但备注时间较新则替换
                    else if(getters.remarkList[i].isAdmin !== "1" &&creatorUidRecord.indexOf(getters.remarkList[i].uid) !== -1 &&
                        parseInt(creatorCreateTimeRecord[creatorUidRecord.indexOf(getters.remarkList[i].uid)]) <= parseInt(getters.remarkList[i].timestamp)){
                        //replace
                        creatorCreateTimeRecord.splice(creatorUidRecord.indexOf(getters.remarkList[i].uid),1,getters.remarkList[i].timestamp);

                        creatorAll.splice(creatorUidRecord.indexOf(getters.remarkList[i].uid),1,{
                            name : getters.remarkList[i].username,
                            value : getters.remarkList[i].uid,
                            status: getters.remarkList[i].status,
                            progress:getters.remarkList[i].progress,
                            returnDate:getters.remarkList[i].nexttime,
                            isAdmin : getters.remarkList[i].isAdmin
                        });
                    }
                }

                //计算联系对象
                if(getters.remarkList[i].contactUid && getters.remarkList[i].isAdmin !== "1"){
                    //若没有则添加
                    if(contactUserUidRecord.indexOf(getters.remarkList[i].contactUid) === -1){
                        //push
                        contactUserUidRecord.push(getters.remarkList[i].contactUid);

                        contactUser.push({
                            name:getters.remarkList[i].contact,
                            value:getters.remarkList[i].contactUid
                        });
                    }
                }

                //计算联系类型
                if(getters.remarkList[i].contact_type_id && getters.remarkList[i].isAdmin !== "1"){
                    //若没有则添加
                    total ++;
                    if(contactTypeIdRecord.indexOf(getters.remarkList[i].contact_type_id) === -1){
                        contactTypeIdRecord.push(getters.remarkList[i].contact_type_id);
                        contactType.push({
                            name:getters.remarkList[i].contact_type,
                            value:getters.remarkList[i].contact_type_id,
                            number:1,
                        })
                    }
                    //如存在则number+1
                    else{
                        contactType[contactTypeIdRecord.indexOf(getters.remarkList[i].contact_type_id)].number ++ ;
                    }
                }
            }

            //整合结果
            res.date = [...list.date];
            res.creator = [...list.creator,...creatorAll];
            res.contactUser = [...list.contactUser,...contactUser];
            res.contactType = [...list.contactType,...contactType];
            res.effectFollow = [...list.effectFollow];
            res.contactType[0].number = total;
            return res;
        },
        //我最新创建的一条备注的联系对象和项目进度数据及项目状态
        lastContactAndProgress : state => {
            let res = {
                contact : "",       //联系对象
                progress : "",      //项目进度
                status : "",        //项目状态
            };
            for(let i = 0 ; i < state.remarkData.length; i++){
                if(state.remarkData[i].myself === "1"){
                    res.contact = state.remarkData[i].contactUid ? state.remarkData[i].contactUid : "";
                    res.progress = state.remarkData[i].progressId ? state.remarkData[i].progressId : "";
                    res.status = state.remarkData[i].statusId ?  state.remarkData[i].statusId : "";
                    break;
                }
                continue;
            }

            return res;
        },
        //去空格后额外的@字符串
        extraString : state => {
            return state.extraStr.trim();
        },
        //是否清空文本域标志位
        clearTextArea : state => {
            return state.doClearTextArea;
        },
    },
    mutations : {
        /**
         * 设置isAdmin的值
         * @param {object} state 状态
         * @param {string} data 待赋值的数据
         */
        setIsAdmin(state,data="0"){
            state.isAdmin = data;
        },
        /**
         * 重置清空并初始化所有备注相关的数据
         * @param {object} state 状态
         * @param {object} param {type:string类型1-项目，2-载体,id:string项目|载体 id}
         * @returns {boolean}
         */
        clearAllData(state,param={type:"",id:""}){
            let type = param.type;
            let id = param.id;
            if(!type || !id){
                utils.notice("初始化备注数据失败，请刷新重试","error");
                return false;
            }
            state.type = type;
            state.id = id;
            state.initCount = 0;
            state.initStatus = {
                noteOptions : 0,
                contactList : 0,
                atUserList  : 0,
                remarkData : 0,
            };
            //左侧
            state.noteOptions = Object.assign({},{
                //项目状态
                status : [],
                //联系对象
                contact : [],
                //联系类型
                contactType : [],
                //项目进度
                progress : []
            });
            //右侧
            state.contactList = Object.assign({},{
                //最近联系人
                nearBy : [],
                //常用联系人
                always : [],
                //官方联系人
                official: [],
            });
            //备注相关
            state.remarkData = [];
            //额外字符串
            state.extraStr = "";
        },
        /**
         * 手动设置区域数据加载状态
         * @param {state} state 状态
         * @param {object} params {name:string字段名,value:bool字段值}
         */
        setInitStatus(state,params){
            state.initStatus[params.name] = params.value;
        },
        /**
         * 设置noteOptions的数据
         * @param {object} state 状态
         * @param {object} data 待赋值的数据
         */
        setNoteOptions(state,data={}){
            state.noteOptions = Object.assign({},data);
        },
        /**
         * 设置contactList的数据
         * @param {object} state 状态
         * @param {object} data 待赋值的数据
         */
        setContactList(state,data={}){
            state.contactList = Object.assign({},data);
        },
        /**
         * 设置atUserList数据
         * @param {object} state 状态
         * @param {object} data 待赋值的数据
         */
        setAtUserList(state,data=[]){
            state.atUserList = [...data];
        },
        /**
         * 设置remarkData数据
         * @param {object} state 状态
         * @param {object} data 待赋值的数据
         */
        setRemarkData(state,data=[]){
            state.remarkData = [...data];
        },
        /**
         * 设置searchItem数据
         * @param {object} state 状态
         * @param {object} data 待赋值的数据
         */
        setSearchItem(state,data={}){
            state.searchItem = Object.assign({},data);
        },
        /**
         * 设置extraStr
         * @param {object} state 状态
         * @param {string} data 赋值的字符串
         */
        setExtraStr(state,data=""){
            state.extraStr = data;
        },
        /**
         * 修改某条备注的置顶状态
         * @param {object} state 状态
         * @param {object} param {id:string 备注id,isTop:1-置顶，2-不置顶}
         */
        setIsTop(state,param={id:"",isTop:""}){
            for(let i = 0 ; i < state.remarkData.length ;i++){
                if(state.remarkData[i].id === param.id){
                    state.remarkData[i].istop = param.isTop;
                    break;
                }
            }
            return true;
        },
        /**
         * 移除某条备注
         * @param {object} state 状态
         * @param {object} param {id:string 待删除备注id}
         */
        removeOneRemark(state,param={id:id}){
            if(param.id){
                let index = -1;
                for(let i = 0 ; i < state.remarkData.length; i++){
                    if(state.remarkData[i].id === param.id){
                        index = i;
                        break;
                    }
                }
                if(index >= 0){
                    state.remarkData.splice(index,1);
                }
            }
        },
        /**
         * 向remarkData添加数据
         * @param {object} state 桩体
         * @param {object} data 待添加的数据
         * @returns {boolean}
         */
        addRemarkData(state,data={}){
            if(!data){
                return false;
            }
            state.remarkData.splice(0,0,data);
        },
        /**
         * 设置添加按钮加载状态
         * @param {object} state 状态
         * @param {bool} data 是否加载true-是
         */
        setAddLoading(state,data=false){
            state.addLoading = data;
        },
        /**
         * 手动设置clearTextArea
         * @param {object} state 状态
         * @param {bool} data 带设置的状态
         */
        setClearTextArea(state,data=false){
            state.doClearTextArea = data;
        },
        /**
         * 手动设置editLoading
         * @param {object} state 状态
         * @param {bool} data 修改的值
         */
        setEditLoading(state,data=false){
            state.editLoading = data;
        },
        /**
         * 手动更新一条对应id的备注内容
         * @param {object} state 状态
         * @param {object} data {id:string待更新备注的id,data:object待更新备注的内容}
         */
        updateOneRemark(state,data={id:"",data:{}}){
            if(!data || !data.id || !data.data){
                return false;
            }
            for(let i = 0 ; i < state.remarkData.length; i ++){
                if(data.id === state.remarkData[i].id){
                    state.remarkData.splice(i,1,data.data);
                    break;
                }
            }
        },
        /**
         * 手动设置setReplyLoading
         * @param {object} state 状态
         * @param {bool} data 待设置的值
         */
        setReplyLoading(state,data=false){
            state.replyLoading = data;
        },
        /**
         * 回复备注之后做数据更新
         * @param {object} state 状态
         * @param {object} data {newCloud:object新生成的备注,replyCloud:object当前回复的备注} 回复成功后后台返回的数据
         */
        afterReplyRemark(state,data={newCloud:{},replyCloud:{}}){
            //先更新回复的备注的数据
            for(let i = 0 ; i < state.remarkData.length ; i ++ ){
                if(state.remarkData[i].id === data.replyCloud.id){
                    let newObj = Object.assign({},data.replyCloud);
                    state.remarkData.splice(i,1,newObj);
                    break;
                }
            }
            //插入新生成的备注
            if(!(data.newCloud && Object.keys(data.newCloud).length > 0) || (Array.isArray(data.newCloud) && data.newCloud.length <= 0)){
                return false;
            }
            let extraObj = Object.assign({},data.newCloud);
            state.remarkData.splice(0,0,extraObj);
        },
        /**
         * 更新常用联系人
         * @param {object} state 状态
         * @param {array} data 常用联系人数据
         */
        updateAlwaysContact(state,data=[]){
            state.contactList = Object.assign(state.contactList,{always:data});
        },
        /**
         * 更新最近联系人
         * @param {object} state 状态
         * @param {array} data 最近联系人数据
         */
        updateRecentContact(state,data=[]){
            state.contactList = Object.assign(state.contactList,{nearBy:data});
        },
        /**
         * 修改 刷新最近联系人进行状态
         * @param {object} state 状态
         * @param {boolean} data 修改的内容
         */
        setRefreshNearByLoading(state,data=false){
            state.refreshNearByLoading = data;
        },
    },
    actions : {
        /**
         * 初始化备注编辑区的数据
         * @param {commit,state} Vuex自身参数
         */
        initEditArea({commit,state}){
            let id = state.id;
            let type = "";
            switch (state.type){
                case "1":
                    type = "item";
                    break;
                case "2":
                    type = "carrier";
                    break;
                default:
                    break;
            }
            if(!id || !type){
                utils.notice("获取备注相关数据失败，请刷新重试","error");
                return false;
            }
            if(state.initStatus.noteOptions === 0){
                //获取左侧表单备选项
                //改变加载状态
                commit("setInitStatus",{name:"noteOptions",value:1});
                //axios
                $api.getEditFormOptions(id,type).then(res=>{
                    if(res.code === "200"){
                        commit("setNoteOptions",res.data);
                        commit("setInitStatus",{name:"noteOptions",value:2});
                    }else{
                        utils.notice("获取备注相关数据[备选项]失败，请刷新重试","error");
                        return false;
                    }
                });
            }
            if(state.initStatus.contactList === 0){
                //获取右侧联系人数据
                commit("setInitStatus",{name:"contactList",value:1});
                $api.getContactList("1,2,3",{"type":type==="item" ? "1" : "2","typeId":id}).then(res=>{
                    if(res.code !== "200"){
                        utils.notice("获取备注相关数据[联系人]失败，请刷新重试","error");
                        return false;
                    }
                    commit("setContactList",res.data);
                    commit("setInitStatus",{name:"contactList",value:2});
                });
            }
            if(state.initStatus.atUserList === 0){
                //获取@人员备选数据
                commit("setInitStatus",{name:"atUserList",value:1});
                $api.getAtContactList(id,type).then(res=>{
                    if(res.code !== "200"){
                        utils.notice("获取备注相关数据[at列表]失败，请刷新重试","error");
                        return false;
                    }
                    commit("setAtUserList",res.data);
                    commit("setInitStatus",{name:"atUserList",value:2});
                });
            }
        },
        /**
         * 初始化
         * @param {commit,state} Vuex自身参数
         */
        initRemarkData({commit,state}){
            let id = state.id;
            let type = "";
            switch (state.type){
                case "1":
                    type = "item";
                    break;
                case "2":
                    type = "carrier";
                    break;
                default:
                    break;
            }
            if(!id || !type){
                utils.notice("获取备注相关数据失败，请刷新重试","error");
                return false;
            }
            //axios
            if(state.initStatus.remarkData === 0){
                commit("setInitStatus",{name:"remarkData",value:1});
                $api.getRemarkListData(id,type).then(res=>{

                    if(res.code !== "200"){
                        utils.notice("获取备注相关数据[备注]失败，请刷新重试","error");
                        return false;
                    }
                    commit("setRemarkData",res.data);
                    commit("setInitStatus",{name:"remarkData",value:2});
                });
            }
        },
        /**
         * 修改某条备注的置顶状态
         * @param {commit,state}  Vuex自带参数
         * @param {object} param {id:string 备注id,isTop:1-置顶，2-不置顶}
         */
        changeIsTop({commit,state},param={id:"",isTop:""}){

            if(!param.id || !param.isTop){
                return false;
            }
            let type = "";
            let tip = param.isTop==="1" ? "置顶" : "取消置顶";
            if(state.type === '1'){
               type = "item";
            }else{
               type = "carrier";
            }
            $api.changeRemarkIsTop(state.id,type,param).then(res=>{
                if(res.code === "200"){
                    utils.notice(`${tip}成功`,"success");
                    commit("setIsTop",param);
                }else{
                    utils.notice(res.msg,"error");
                    return false;
                }
            })
        },
        /**
         * 删除某条备注
         * @param {commit,state}  Vuex自身参数
         * @param {object} param {id:string 待删除备注的id}
         * @returns {boolean}
         */
        deleteRemark({commit,state},param={id:""}){
            if(!param.id){
                return false;
            }
            let type = "";
            if(state.type === '1'){
                type = "item";
            }else{
                type = "carrier";
            }
            $api.deleteRemarkById(state.id,type,param.id).then(res=>{
                if(res.code === "200"){
                    utils.notice("删除成功","success");
                    commit("removeOneRemark",param);
                }else{
                    utils.notice(res.msg,"error");
                    return false;
                }
            });

        },
        /**
         * 新增一条备注
         * @param {commit,state} vuex 自带参数
         * @param {object} param 待提交的数据
         */
        addOneRemark({commit,state},param={}){
            if(!param){
                return false;
            }
            let postData = {
                "itemId"            : state.id,
                "status"            : param.status,
                "type"              : state.type,
                "contact"           : param.contact ? param.contact : "",
                "contactType"       : param.contactType ? param.contactType : "",
                "progress"          : param.progress ? param.progress : "",
                "nexttime"          : !param.returnDate ? "" : (`${param.returnDate.getFullYear()}-${parseInt(param.returnDate.getMonth())+1}-${param.returnDate.getDate()} ${param.returnTime ? param.returnTime : ""}`),
                "emergency"         : param.urgentAt===true ? "2" : "1",
                "effective_follow"  : param.effectFollow === true ? "2" : "1",
                "cloud"             : param.remarkTest ? param.remarkTest : "",
            };
            //axios
            commit("setAddLoading",true);
            commit("setClearTextArea",false);
            $api.addNewRemark(postData).then(res=>{
                commit("setAddLoading",false);
                if(res.code === "200"){
                    commit("setClearTextArea",true);
                    commit("addRemarkData",res.data);
                    utils.notice("备注成功","success");
                }else{
                    utils.notice(res.msg,"error");
                    return false;
                }
            });
        },
        /**
         * 编辑一条备注
         * @param {commit,state} vuex 自带参数
         * @param {object} param 待提交的数据
         */
        editOneRemark({commit,state},param={}){
            if(!param || !param.id){
                return false;
            }
            let type = "";
            if(state.type === '1'){
                type = "item";
            }else{
                type = "carrier";
            }
            let postData = {
                "cloudId" : param.id,
                "cloud" : param.remarkTest,
                "atUsers" : param.checkUsers,
            };
            commit("setEditLoading",true);
            $api.editRemark(state.id,type,postData).then(res=>{
                commit("setEditLoading",false);
                if(res.code === "200"){
                    utils.notice("修改成功","success");
                    commit("updateOneRemark",{id:postData.cloudId,data:res.data});
                }else{
                    utils.notice(res.msg,"error");
                    return false;
                }
            });
        },
        /**
         * 回复一条备注
         * @param {commit,state} Vuex默认参数
         * @param {object} param 待提交的内容
         */
        replyRemark({commit,state},param={}){
            if(!param){
                return false;
            }
            //获取类型
            let type = "";
            if(state.type === '1'){
                type = "item";
            }else{
                type = "carrier";
            }
            //待提交的数据
            let postData = Object.assign({
                "itemId" : state.id,
                "type"  :   state.type
            },param);

            //axios
            commit("setReplyLoading",true);
            $api.replyRemark(state.id,type,postData).then(res => {
                commit("setReplyLoading",false);
                if(res.code === "200"){
                    utils.notice("回复成功","success");
                    commit("afterReplyRemark",res.data);
                }else{
                    utils.notice(res.msg,"error");
                    return false;
                }
            });
        },
        /**
         * 管理常用联系人
         * @param {commit} Vuex自带参数
         * @param {object} param  {uids:array 常用联系人uid}
         */
        changAlwaysConnectList({commit},param={uids : []}){
            $api.editAlwaysContactUsers(param.uids).then(res=>{
                if(res.code === "200"){
                    //更新常用联系人列表
                    utils.notice("修改成功","success");
                    let newUsers = [...res.data];
                    commit("updateAlwaysContact",newUsers);
                } else{
                    utils.notice(res.msg,"error");
                    return false;
                }
            });
        },
        /**
         * 刷新最近联系人数据
         * @param {commit,state} Vuex 自带参数
         */
        refreshContactList({commit,state}){
            //这块上来先判断一下，防止同时刻多个请求一并刷新最近联系人导致1s内发起多次重复请求
            if(state.refreshNearByLoading === true){
                return false;
            }
            let id = state.id;
            let type = "";
            switch (state.type){
                case "1":
                    type = "item";
                    break;
                case "2":
                    type = "carrier";
                    break;
                default:
                    break;
            }
            commit("setRefreshNearByLoading",true);
            $api.getContactList("1",{"type":type,"typeId":id}).then(res=>{
                if(res.code !== "200"){
                    utils.notice("刷新最近联系人失败，请刷新重试","error");
                    return false;
                }
                commit("updateRecentContact",res.data.nearBy);
                commit("setRefreshNearByLoading",false);
            });
        },
        /**
         * 单独更新左侧表单备选项
         * @param commit
         * @param state
         */
        refreshLeftContactList({commit,state}){
            let id = state.id;
            let type = "";
            switch (state.type){
                case "1":
                    type = "item";
                    break;
                case "2":
                    type = "carrier";
                    break;
                default:
                    break;
            }
            $api.getEditFormOptions(id,type).then(res=>{
                if(res.code === "200"){
                    commit("setNoteOptions",res.data);
                }else{
                    utils.notice("获取备注相关数据[备选项]失败，请刷新重试","error");
                    return false;
                }
            });
        }
    }

}


// WEBPACK FOOTER //
// ./src/store/modules/remark.js